export type RecomMethod = 'GET' | 'POST' | 'PUT';

export const recomPaths = {
	recommendation: (): string => 'recommendation',
};

const RECOM_ALLOWED_ROUTES: { method: RecomMethod; path: string }[] = [
	{ method: 'POST', path: recomPaths.recommendation() },
];

export const isAllowedRecomRoute = (method: string, path: string): boolean =>
	RECOM_ALLOWED_ROUTES.some((route) => route.method === method && route.path === path);
